import { useFetcher } from 'libs/fetcher'
import * as R from 'ramda'
import { locales } from 'app/translations/intl-context'
import { useCallback, useMemo } from 'react'
import { sortLanguage } from 'commons/language'
import effects from 'app/effects/effects'
import { useDefaultLanguage } from 'commons/useDefaultLanguage'

const localizationLanguageSelected = [
  {
    code: 'en',
    name: 'English',
  },
  {
    code: 'th',
    name: 'ภาษาไทย',
  },
]

export default () => {
  const defaultLanguge = useDefaultLanguage()
  const getAllLanguage = useCallback(
    () =>
      effects.apis
        .getAllLanguage()
        .then(R.over(R.lensProp('data'), sortLanguage)),
    [],
  )

  const state = useFetcher(getAllLanguage, undefined)

  const items = R.path(['values', 'data'])(state)
  const isLoading = R.prop('isLoading', state)
  const itemsByCode = useMemo(() => {
    if (!items) return new Map()
    return items.reduce((map, item) => {
      map.set(item.code, item)
      return map
    }, new Map())
  }, [items])

  const filterItemLanguage = (item) => {
    return R.has(item.code, locales)
  }

  const filterLocalizationLanguage = (items, locales) => {
    if (items && locales) {
      return R.filter(filterItemLanguage, items)
    } else {
      return [defaultLanguge]
    }
  }

  return {
    items,
    isLoading,
    itemsByCode,
    localizationLanguageItems: filterLocalizationLanguage(items, locales),
    getAllLanguage,
    localizationLanguageSelected,
  }
}
